import React from "react";
import { motion } from "framer-motion";

import { styles } from "../styles";
import {
  drone,
  mobilephone,
  sketch,
  autocad,
  autodesk,
  sketchup,
  arrow,
  editor,
  collage,
} from "../assets";
import { SectionWrapper } from "../hoc";
import { fadeIn, textVariant } from "../utils/motion";

const Product = () => {
  return (
    <>
      <motion.div variants={textVariant()}>
        <p className={styles.sectionSubText}>Product</p>
        <h2 className={styles.sectionHeadText}>Cobotiks Studio</h2>
      </motion.div>

      {/* <motion.p
        variants={fadeIn("", "", 0.1, 1)}
        className="mt-4 text-gray-300 text-[17px] max-w-3xl leading-[30px]"
      >
        Realistic 3D model rendering in AR with accurate localisation
      </motion.p> */}
      <div className="sm:flex items-center justify-center">
        <div className="mt-16 items-start justify-start  gap-10">
          <article class="mb-4 hover:animate-background rounded-xl bg-gradient-to-r from-green-300 via-blue-500 to-purple-600 p-0.5 shadow-xl transition hover:bg-[length:400%_400%] hover:shadow-sm hover:[animation-duration:_4s]">
            <div class="rounded-[10px] bg-white p-4 sm:p-6">
              <div class="flex gap-5">
                <img src={drone} width={50} height={50}></img>
                <img src={sketch} width={40} height={40}></img>
                <img src={mobilephone} width={40} height={40}></img>
              </div>
              <div class="mt-2 flex flex-wrap gap-1">
                <span class="whitespace-nowrap rounded-full bg-purple-100 px-2.5 py-0.5 text-xs text-purple-600">
                  Drone
                </span>
                <span class="whitespace-nowrap rounded-full bg-purple-100 px-2.5 py-0.5 text-xs text-purple-600">
                  Sketch
                </span>
                <span class="whitespace-nowrap rounded-full bg-purple-100 px-2.5 py-0.5 text-xs text-purple-600">
                  Mobile phones
                </span>
              </div>
              <time class="block text-sm font-medium mt-2 text-purple-800">
                Images + Text
              </time>
              <a>
                <h3 class="mt-0.5 text-md text-gray-900">
                  Provide Images with description or just text Input
                </h3>
              </a>
            </div>
          </article>
          <article class="hover:animate-background rounded-xl bg-gradient-to-r from-green-300 via-blue-500 to-purple-600 p-0.5 shadow-xl transition hover:bg-[length:400%_400%] hover:shadow-sm hover:[animation-duration:_4s]">
            <div class="rounded-[10px] bg-white p-4 sm:p-6">
              <div class="flex gap-10">
                <img src={autocad} width={50} height={50}></img>
                <img src={autodesk} width={40} height={40}></img>
                <img src={sketchup} width={40} height={40}></img>
              </div>
              <div class="mt-2 flex flex-wrap gap-1">
                <span class="whitespace-nowrap rounded-full bg-purple-100 px-2.5 py-0.5 text-xs text-purple-600">
                  AutoCad
                </span>
                <span class="whitespace-nowrap rounded-full bg-purple-100 px-2.5 py-0.5 text-xs text-purple-600">
                  AutoDesk
                </span>
                <span class="whitespace-nowrap rounded-full bg-purple-100 px-2.5 py-0.5 text-xs text-purple-600">
                  Sketchup
                </span>
              </div>
              <time class="block text-sm font-medium mt-2 text-purple-800">
                3D Models
              </time>
              <a>
                <h3 class="mt-0.5 text-md text-gray-900">
                  Provide 3D designs from popular softwares as Input
                </h3>
              </a>
            </div>
          </article>
        </div>
        <div class="sm:w-[10%] m-4 ml-8 flex items-center justify-center">
          <img class="w-1/4 sm:w-full rotate-90 sm:rotate-0" src={arrow}></img>
        </div>
        <div className="flex-row text-center items-center justify-center">
          <h1 className="text-4xl mt-16">Cobotiks Studio </h1>
          <img className="mt-8" src={editor}></img>
        </div>
      </div>
      <div class="sm:w-[65%] m-4 ml-8 sm:ml-16 flex items-center justify-end">
        <img class="w-[10%] mt-10 rotate-90" src={arrow}></img>
      </div>
      <div class="sm:w-[89%] m-4 ml-8 flex  mt-4 items-center justify-end">
        <img width={600} src={collage}></img>
      </div>
    </>
  );
};

export default SectionWrapper(Product, "product");
